import React, { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from "react-router-dom";
import '../../Modal/modal.css';
import PearsonLogo from '../../../../images/pearson_logo.png';
import renameButton from '../../../../images/icon_rename.gif';
import apiService from '../../../utils/apiService';
import {
    applyRenameValidationResult,
    buildRenamePayload,
    getFileNameAndExtension,
    getRenameApiErrorMessage,
    getRenameInputFieldError,
    validateRenameFolderInput,
} from '../renameFolderHelpers';
import { useSoftDeletedNames } from '../useSoftDeletedNames';
import { getSubDirectories } from '../../../Dashboard/actions';
import { updateGenricSuccessMessageToEmpty } from '../../../User/actions';
import {
    USER_DISPLAY_MSG,
    RENAME_FOLDER_API,
    DISALLOWED_FILE_NAME_CHAR_MESSAGE,
    stripDisallowedFileNameChars,
    shouldBlockFileNameKeyEvent,
} from '../../../../Constants';

const RenameFolder = ({isOpen, onRequestClose, currentPath, renamefolder}) => {

    const dispatch = useDispatch();
    const directoriesList = useSelector(state => state.directoriesReducer.serverResponse);
    const { name: originalName, extension, isFile } = useMemo(
        () => getFileNameAndExtension(renamefolder || ''),
        [renamefolder]
    );
    const [editableName, setEditableName] = useState(originalName);
    const [renameFolderErrMsg, setRenameFolderErrMsg] = useState('');
    const softDeletedNames = useSoftDeletedNames(currentPath, isOpen);
    const [searchParams, setSearchParams] = useSearchParams();

    const folderName = isFile ? editableName + extension : editableName;

    const existingNames = useMemo(() => {
        if (!directoriesList?.data) return [];
        return directoriesList.data
            .map(item => item.directory)
            .filter(name => name && name !== renamefolder);
    }, [directoriesList, renamefolder]);

    React.useEffect(() => {
        setEditableName(originalName);
        setRenameFolderErrMsg('');
    }, [originalName, isOpen]);

    const onModalpopupClose = (e) =>{
        if (searchParams.has('rename')) {
            searchParams.delete('rename');
            setSearchParams(searchParams);
        }
        onRequestClose(isOpen);
    }

   const renameFolder = async (e) => {
    e.preventDefault();

    const validation = validateRenameFolderInput({
        folderName,
        renamefolder,
        existingNames,
        softDeletedNames,
    });

    if (!applyRenameValidationResult(validation, {
        setError: setRenameFolderErrMsg,
        setEditableName,
        originalName,
    })) {
        return;
    }

    try {
        const response = await apiService.post(
            RENAME_FOLDER_API,
            buildRenamePayload(currentPath, renamefolder, folderName)
        );
        const apiError = getRenameApiErrorMessage(response?.data);
        if (apiError) {
            dispatch(updateGenricSuccessMessageToEmpty({}));
            setRenameFolderErrMsg(apiError);
            return;
        }

        dispatch({ type: USER_DISPLAY_MSG, response: response.data });
        dispatch(getSubDirectories({ dir: currentPath }));
        onModalpopupClose();
    } catch {
        setRenameFolderErrMsg('Error renaming files.');
    }
};

    const handleRenameKeyDown = e => {
        if (shouldBlockFileNameKeyEvent(e)) {
            e.preventDefault();
            setRenameFolderErrMsg(DISALLOWED_FILE_NAME_CHAR_MESSAGE);
        }
    };

    const updateFolderName = e => {
        e.preventDefault();
        const raw = e.target.value;
        const cleaned = stripDisallowedFileNameChars(raw);
        const finalName = isFile ? cleaned + extension : cleaned;
        setRenameFolderErrMsg(getRenameInputFieldError(raw, cleaned, finalName));
        setEditableName(cleaned);
    }

    return(
        <div className="modal-content-table" >

            <table border="0" width="99%" cellSpacing="3" cellPadding="0" >
                <tr align="left" valign="top">
                <td align="left" valign="middle"><span class="pagetitle">&nbsp;Rename Folder</span></td>
                    <td align="right" valign="middle"><img src={PearsonLogo} title="Pearson Education" alt="Pearson Education" width="85" height="21" hspace="0" vspace="0" border="0"/></td>
                    <td><span
                            className="close"
                             onClick={onModalpopupClose}>&times;
                        </span>
                    </td>
                </tr>
            </table>
            <div id="background" className='create-new-folder'>

            </div>


            <div id="table" className='unzip-table'>
                <table border="0" width="99%" cellSpacing="0" cellPadding="0">
                    <tr align="left" valign="top">
                        <td align="left" valign="top" width="90"><img src={renameButton} alt="New Folder" width="90" height="68" hspace="0" vspace="0" border="0"/></td>
                        <td align="center" valign="middle"class="instructions">
                            <span>
                                To rename a file or folder, enter the new name below and click "Rename".
                            </span>
                            <br/>
                            <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                                <input type="text" size="24" name="newfolder_name" className='create-new-folder-input' value={editableName} onChange={updateFolderName} onKeyDown={handleRenameKeyDown} />
                                {isFile && extension && <span style={{ marginLeft: '2px', fontWeight: 'bold' }}>{extension}</span>}
                            </span>
                            <br/>
                            <table width="50%" border="0" cellSpacing="0" cellPadding="0" align="center">
                                <tr align="center">
                                    <td align="center" valign="middle"><input name="" type="button" class="unzip-formButton" value="&nbsp;Cancel&nbsp;" onClick={onModalpopupClose}/></td>
                                    <td align="center" valign="middle"><input name="" type="button" class="unzip-formButtonGo" value="&nbsp;&nbsp;Rename&nbsp;&nbsp;" onClick = {renameFolder}/></td>
                                </tr>
                            </table>
                            <br/>
                            <span className='create-new-folder-ErrorMsg'>
                                {renameFolderErrMsg}
                            </span>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    );

}

export default RenameFolder
